import React from "react";
import Cookies from "js-cookie";

interface State {
    visible: boolean;
    message: string | undefined;
}

/**
 * Displays the alert row.
 */
export default class AlertRow extends React.Component<{}, State> {
    // Flag to use for preventing unmounted component from updating
    _isMounted: boolean = false;

    constructor(props: {}) {
        super(props);

        // Checking whether the alert message in the cookies is present.
        let message = Cookies.get("alertMessage");
        let visibility = false;
        if (message != undefined && message.trim() != "") {
            visibility = true;
        }
        Cookies.remove("alertMessage");

        this.state = {
            visible: visibility,
            message: message
        };
    }

    componentDidMount() {
        let caller = this;
        this._isMounted = true;
        setTimeout(function() {
            if (caller._isMounted) {
                caller.setState({
                    visible: false,
                });
            }
        }, 3000);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        let display;
        if (this.state.visible) {
            display = "block";
        } else {
            display = "none";
        }

        return (
            <div className="row alert-row" style={{ display: display }}>
                <div className="col-12">
                    <div className="alert alert-success" role="alert">
                        {this.state.message}
                    </div>
                </div>
            </div>
        );
    }
}
